import { GetPayUpType, GetUserType } from '@orbit/api-types'
import React from 'react'
import { MoneyBillIcon } from '@/assets/icons'
import { Avatar } from '../Avatar'
import { ActivityPerson, formatAmount } from '../balancesFormat'
import {
	ActivityCard,
	ActivityCardBottom,
	ActivityCardCurrencyCode,
	PaidConnector,
	PayerAmount,
	PayerLine,
	PayerName,
	PayUpArrow,
	PayUpAvatarRow,
	PayUpMoneyIcon,
} from './ActivitySection.styles'
import { TestIds } from '@/testIds'

interface Props {
	payUp: GetPayUpType
	/** The signed-in viewer; undefined on the public surface (no "You" highlight). */
	me: GetUserType | undefined
	fromUser: ActivityPerson | undefined
	toUser: ActivityPerson | undefined
	fromShortName: string
	fromFullName: string
	toShortName: string
	toFullName: string
	showCurrencyCode: boolean
	/** Omit to render the card read-only (public surface). */
	onClick?: () => void
}

const PayUpCard: React.FC<Props> = ({
	payUp,
	me,
	fromUser,
	toUser,
	fromShortName,
	fromFullName,
	toShortName,
	toFullName,
	showCurrencyCode,
	onClick,
}) => {
	const isMeFrom = !!me && payUp.fromUserId === me.id
	const isMeTo = !!me && payUp.toUserId === me.id
	return (
		<ActivityCard $interactive={!!onClick} onClick={onClick} data-testid={TestIds.payUp.timelineCell}>
			<PayUpAvatarRow>
				<Avatar member={fromUser} size="md" />
				<PayUpMoneyIcon aria-hidden="true">
					<MoneyBillIcon />
				</PayUpMoneyIcon>
				<PayUpArrow aria-label="paid">→</PayUpArrow>
				<Avatar member={toUser} size="md" />
			</PayUpAvatarRow>
			<ActivityCardBottom>
				<PayerLine>
					<PayerName $highlight={isMeFrom} title={isMeFrom ? undefined : fromFullName}>
						{isMeFrom ? 'You' : fromShortName}
					</PayerName>
					<PaidConnector>paid</PaidConnector>
					<PayerName $highlight={isMeTo} title={isMeTo ? undefined : toFullName}>
						{isMeTo ? 'You' : toShortName}
					</PayerName>
					<PayerAmount>
						{formatAmount(payUp.amount, payUp.currencyCode)}
						{showCurrencyCode && (
							<ActivityCardCurrencyCode>
								{payUp.currencyCode.toUpperCase()}
							</ActivityCardCurrencyCode>
						)}
					</PayerAmount>
				</PayerLine>
			</ActivityCardBottom>
		</ActivityCard>
	)
}

export default PayUpCard
